import { z } from 'zod';
import { defineEndpoint } from '../define';
import { PollDetailSchema, PollFieldInputSchema, PollResultsVisibilitySchema } from './shapes';

export const CreatePollBodySchema = z.object({
  title: z.string().trim().min(1).max(300),
  description: z.string().trim().max(5_000).default(''),
  isAnonymous: z.boolean().default(false),
  allowEdit: z.boolean().default(true),
  resultsVisibility: PollResultsVisibilitySchema.default('live'),
  closesAt: z.string().datetime().nullable().default(null),
  fields: z.array(PollFieldInputSchema).max(200).default([]),
});
export type CreatePollBody = z.input<typeof CreatePollBodySchema>;

export const createPoll = defineEndpoint({
  method: 'POST',
  path: '/v1/polls',
  params: z.object({}),
  query: z.object({}),
  body: CreatePollBodySchema,
  response: z.object({ data: PollDetailSchema }),
  successStatus: 201,
});
